export const auth = {
  email: 'Correo electrónico',
  emailPlaceholder: 'Ingresa tu correo electrónico',
  password: 'Contraseña',
  passwordPlaceholder: 'Ingresa tu contraseña',
  confirmPassword: 'Confirmar Contraseña',
  confirmPasswordPlaceholder: 'Confirma tu contraseña',
  firstName: 'Nombre',
  firstNamePlaceholder: 'Ingresa tu nombre',
  lastName: 'Apellido',
  lastNamePlaceholder: 'Ingresa tu apellido',
  signIn: 'Iniciar sesión',
  signInDescription: 'Inicia sesión en tu cuenta',
  signUp: 'Registrarse',
  signUpDescription: 'Crea tu cuenta de Referent',
  forgotPassword: '¿Olvidaste tu contraseña?',
  forgotPasswordTooltip: 'Comunícate con nuestro equipo para restablecerla',
  rememberMe: 'Recordarme',
  noAccount: '¿No tienes una cuenta?',
  haveAccount: '¿Ya tienes una cuenta?',
  loginSuccess: '¡Bienvenido de nuevo!',
  registerSuccess: '¡Cuenta creada exitosamente! Por favor inicia sesión.',
  passwordMismatch: 'Las contraseñas no coinciden',
  maintenance: {
    title: 'Estamos trabajando en algo increíble',
    greeting: '¡Hola {{name}}!',
    subtitle:
      'Nuestro equipo está trabajando duro para poder brindarte las mejores herramientas para que tus equipos rindan mejor ¡Nos vemos dentro de muy poco!',
  },
} as const
